
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { AlertTriangle, Bell, Shield } from 'lucide-react';

export const AuditSummaryCards: React.FC = () => {
  return (
    <div className="grid gap-6 md:grid-cols-3">
      <Card>
        <CardHeader className="pb-1">
          <CardTitle className="text-lg font-medium flex items-center">
            <AlertTriangle size={18} className="mr-2 text-red-500" /> 
            Critical Triggers
          </CardTitle>
          <CardDescription>Requires immediate attention</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">4</div>
          <p className="text-sm text-muted-foreground">2 newly detected this week</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-1">
          <CardTitle className="text-lg font-medium flex items-center">
            <Bell size={18} className="mr-2 text-yellow-500" /> 
            Monitoring Triggers
          </CardTitle>
          <CardDescription>Under active observation</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">3</div>
          <p className="text-sm text-muted-foreground">1 escalated to critical</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-1">
          <CardTitle className="text-lg font-medium flex items-center">
            <Shield size={18} className="mr-2 text-green-500" /> 
            Overall Audit Readiness
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center">
            <span className="text-2xl font-bold mr-2">82%</span>
            <Progress value={82} className="h-2 flex-1" />
          </div>
          <p className="text-sm text-muted-foreground mt-1">+5% from previous month</p>
        </CardContent>
      </Card>
    </div>
  );
};
